<div class="carousel-stay-tuned">
  <div class="carousel-stay-tuned__title text-base-font-primary" translate>global.stay-tuned</div>
  <app-carousel [items]="data | slice: 0 : 5">
    <ng-template let-slide>
      <a class="carousel-stay-tuned__post" [routerLink]="['/post', slide.id]" target="_blank">
        <img class="carousel-stay-tuned__image" loading="lazy" [src]="slide.imagem_mobile" [alt]="slide.titulo" />
        <div class="carousel-stay-tuned__info">
          <p>{{ slide.titulo }}</p>
          <span>{{ slide.chamada }}</span>
        </div>
      </a>
    </ng-template>
  </app-carousel>
</div>
